export function updateBrandSettings(payload) {
    return ({
        type: 'UPDATE_BRAND_DETAILS',
        payload
    })
}